export const transportPlayButtonChrome = {
  width: '105px',
  height: '105px',
  padding: '0px',
  margin: '0px',
  borderRadius: '50%',
  '&:hover': {
    background: 'rgba(212,134,108,1.0)',
    cursor: 'pointer',
    transition: '0.3s',
    boxShadow: '0px 0px 5px 5px rgb(212,134,108,.5)',
  },
};

export const transportRestartButtonChrome = {
  width: '75px',
  height: '75px',
  padding: '0px',
  margin: '0px',
  borderRadius: '50%',
  '&:hover': {
    cursor: 'pointer',
    transition: '0.3s',
    boxShadow: '0px 0px 5px 5px rgb(196,198,202,.5)',
  },
};

export const tempoToggleChrome = {
  display: 'flex',
  alignItems: 'center',
  width: '210px',
  backgroundColor: '#243056',
  borderRadius: '33px',
  padding: '3px',
  '&:hover': {
    cursor: 'pointer',
    transition: '0.3s',
    boxShadow: '0px 0px 5px 5px rgb(222,144,118,.5)',
  },
};

export const tempoToggleTextChrome = {
  marginLeft: '10px',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  color: '#ECECED',
  fontWeight: 700,
};

export const tempoToggleIconChrome = {
  marginLeft: '1px',
  minHeight: '56px',
  marginTop: '1px',
};
